const Status = `
  id
  name
  online
  createdAt
`;
export default Status;
